import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledProductPriceOld = styled.div`
    //font-weight: 500;
    text-decoration-line: line-through;
    color: var(${GLOBAL_STYLE_CONFIG.variable('price', 'old-color')}, ${({theme}) => theme.price.oldColor});
    font-family: inherit;
`

interface IProps {
    children: React.ReactNode;
    className?: string;
}

const ProductOldPrice: React.FC<IProps> = ({children, className = ""}) => {
    const classnames = `${GLOBAL_STYLE_CONFIG.splitByPrefix('price-old')} ${className}`
    return (
        <StyledProductPriceOld className={classnames}>
            {children}
        </StyledProductPriceOld>
    );
};

export default ProductOldPrice;